export default "<p>\n  speed-sensor-element works!\n</p>\n";